import { Text, useMainContext } from '../../../../modules/Dashboard'
import { BsClock } from 'react-icons/bs'
import useTimeFrame, { getFrameLabel, TIME_FRAMES } from './core'
import MobileModal from '../../../../components/layouts/MobileModal'
import { BiChevronDown, BiChevronUp } from 'react-icons/bi'

const RTimeFrameSelect = ({ className = '', dropdownClass = '' }) => {
    const { open, setOpen, timeFrame, handleSelect, shouldRenderTimeFrame } = useTimeFrame()
    const {
        main: { lang },
    } = useMainContext()

    if (!shouldRenderTimeFrame()) return <></>

    const handleTimeFrameSelect = (selectedFrame) => {
        handleSelect(selectedFrame)
        setOpen(false) // Close modal after selection
    }

    return (
        <>
            {/* Toggler Button */}
            <button
                onClick={() => setOpen(true)}
                className={`relative w-full flex items-center gap-2 px-4 py-3 rounded-xl border border-[#364153] transition-colors mt-5 ${className}`}
            >
                <Text tid={"trading-timeframe"} className='absolute -top-8 ltr:left-0 rtl:right-0 text-sm text-[#C27AFF]' />
                <BsClock size={16} />
                <span className="font-medium text-[#6A7282] text-sm">
                    {timeFrame ? timeFrame : (lang === 'fa' ? 'انتخاب بازه زمانی' : 'Select time frame...')}
                </span>
                {open ? (
                    <BiChevronUp color="#6A7282" className="absolute ltr:right-3 rtl:left-3 top-1/2 -translate-y-1/2" size={20} />
                ) : (
                    <BiChevronDown color="#6A7282" className="absolute ltr:right-3 rtl:left-3 top-1/2 -translate-y-1/2" size={20} />
                )}
            </button>

            {/* Mobile Modal */}
            <MobileModal
                isOpen={open}
                onClose={() => setOpen(false)}
                noBg
                noPadding
            >
                <div className="bg-gradient-to-br from-[#101828] via-[#3C036680] to-[#101828] rounded-t-xl p-4">
                    {/* TITLE */}
                    <div className='text-center w-full'>
                        <Text tid={"choose-timeframe"} className='text-xl' />
                    </div>
                    {TIME_FRAMES.map((item) => (
                        <button
                            key={item.frame}
                            onClick={() => handleTimeFrameSelect(item.frame)}
                            className={`w-full px-4 py-3 flex items-center gap-3 transition-colors odd:bg-[#300258] even:bg-[#2B034E] rounded-lg ${timeFrame === item.frame ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400' : ''
                                }`}
                        >
                            <BsClock size={18} className="text-gray-400" />
                            <span className="font-semibold text-white">{item.frame}</span>
                            {timeFrame === item.frame && (
                                <span className="ml-auto text-blue-500 text-sm">
                                    {lang === 'fa' ? 'انتخاب شده' : 'Selected'}
                                </span>
                            )}
                        </button>
                    ))}
                </div>
            </MobileModal>
        </>
    )
}

export default RTimeFrameSelect